// src/services/tokens.js
import api from './api';

export const getTokens = async (params = {}) => {
  const response = await api.get('/tokens/', { params });
  return response.data.map(processTokenResponse);
};

export const getToken = async (id) => {
  const response = await api.get(`/tokens/${id}`);
  return processTokenResponse(response.data);
};

export const createToken = async (tokenData) => {
  const response = await api.post('/tokens/', tokenData);
  return response.data;
};

export const updateToken = async (id, tokenData) => {
  try {
    const cleanData = { ...tokenData };
    delete cleanData.encrypted_data;
    delete cleanData.token_hash;
    
    const response = await api.put(`/tokens/${id}`, cleanData);
    return processTokenResponse(response.data);
  } catch (error) {
    console.error('Update token error:', error.response?.data || error.message);
    throw error;
  }
};

export const deleteToken = async (id) => {
  const response = await api.delete(`/tokens/${id}`);
  return response.data;
};

export const bindTokenToProxy = async (tokenId, proxyId) => {
  const response = await api.post(`/tokens/${tokenId}/bind-proxy/${proxyId}`);
  return response.data;
};

export const unbindTokenFromProxy = async (tokenId, proxyId) => {
  const response = await api.delete(`/tokens/${tokenId}/bind-proxy/${proxyId}`);
  return response.data;
};

export const getTokenStats = async (tokenId) => {
  const response = await api.get(`/tokens/${tokenId}/stats`);
  return response.data;
};

export const bulkUploadTokens = async (file, fileType) => {
  const formData = new FormData();
  formData.append('file', file);
  
  let endpoint = '/bulk-upload/tokens/';
  if (fileType === 'csv') {
    endpoint += 'csv';
  } else if (fileType === 'json') {
    endpoint += 'json';
  } else if (fileType === 'txt') {
    endpoint += 'txt';
  }
  
  const response = await api.post(endpoint, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const getDecryptedToken = async (id) => {
  const response = await api.get(`/tokens/${id}/decrypted`);
  return response.data;
};

export const toggleScheduledMode = async (id, scheduledData) => {
  const response = await api.patch(`/tokens/${id}/schedule`, scheduledData);
  return processTokenResponse(response.data);
};

const processTokenResponse = (token) => {
  // Convert time objects to string format
  if (token.scheduled_start_time && typeof token.scheduled_start_time === 'object') {
    if (token.scheduled_start_time.hour !== undefined && token.scheduled_start_time.minute !== undefined) {
      token.scheduled_start_time = `${token.scheduled_start_time.hour.toString().padStart(2, '0')}:${token.scheduled_start_time.minute.toString().padStart(2, '0')}`;
    } else if (token.scheduled_start_time instanceof Date) {
      token.scheduled_start_time = token.scheduled_start_time.toTimeString().slice(0, 5);
    }
  }
  
  if (token.scheduled_end_time && typeof token.scheduled_end_time === 'object') {
    if (token.scheduled_end_time.hour !== undefined && token.scheduled_end_time.minute !== undefined) {
      token.scheduled_end_time = `${token.scheduled_end_time.hour.toString().padStart(2, '0')}:${token.scheduled_end_time.minute.toString().padStart(2, '0')}`;
    } else if (token.scheduled_end_time instanceof Date) {
      token.scheduled_end_time = token.scheduled_end_time.toTimeString().slice(0, 5);
    }
  }
  
  if (!token.bindings) {
    token.bindings = [];
  }
  
  return token;
};